/**
 * @generated SignedSource<<d178dd83c57213a87662a9f9087417de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNavRefineMenuFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbMobileRefineMenuFilterArtSize_user" | "SbMobileRefineMenuFilterDimensions_user" | "SbMobileRefineMenuFilterPrice_user">;
  readonly " $fragmentType": "BuyMobileNavRefineMenuFilters_user";
};
export type BuyMobileNavRefineMenuFilters_user$key = {
  readonly " $data"?: BuyMobileNavRefineMenuFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNavRefineMenuFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNavRefineMenuFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterArtSize_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6310b3bb89fec71247295e2fd9b3865e";

export default node;
